<template>
    <section aria-hidden="false" aria-labelledby="steps-uid-6-h-0" class="body current" id="steps-uid-6-p-0" role="tabpanel" style="height: 500px;">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="validate">
                    <div class="col-sm-12 col-lg-10 m-t-20">
                        <div class="form-group row">
                            <label class="col-sm-3 text-right control-label col-form-label" for="method">Select Method</label>
                            <div class="col-sm-7">
                                <multiselect :allow-empty="true"
                                             :class="{'is-invalid': submitted && errors.has('method')}"
                                             :options="pricingMethods"
                                             @input="selectPricingMethod"
                                             class="form-control"
                                             data-vv-as="method"
                                             id="method"
                                             label="name"
                                             name="method"
                                             placeholder="Choose Payment Term Method"
                                             track-by="id"
                                             v-model="contract.pricingTerm.method"
                                             v-validate="'required'">
                                    <span class="multiselect__placeholder">Type to search</span>
                                </multiselect>
                                <div class="invalid-feedback" v-if="submitted && errors.has('method')">{{ errors.first('method') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-10 m-t-20">
                        <div class="form-group row">
                            <label class="text-right col-sm-3 control-label col-form-label">Select Currency</label>
                            <div class="col-sm-7">
                                <currency-select :class="{'is-invalid': submitted && errors.has('currency')}"
                                                 @currency-select="setCurrency"
                                                 class="form-control"
                                                 data-vv-as="currency"
                                                 id="currency"
                                                 name="currency"
                                                 ref="reference"
                                                 v-model="contract.pricingTerm.currency"
                                                 v-validate="'required'">
                                </currency-select>
                                <div class="invalid-feedback" v-if="submitted && errors.has('currency')">{{ errors.first('currency') }}</div>
                            </div>
                        </div>
                    </div>
                    <template v-if="selectedPricingMethod === 'Flat'">
                        <div class="col-sm-12 col-lg-10 m-t-20">
                            <div class="form-group row">
                                <label class="text-right col-sm-3 control-label col-form-label">Rate</label>
                                <div class="input-group col-sm-7">
                                    <input :class="{'is-invalid': submitted && errors.has('rate')}"
                                           class="form-control"
                                           data-vv-as="rate"
                                           name="rate"
                                           placeholder="Input Rate"
                                           style="width: 250px; height: 42px;"
                                           type="text"
                                           v-model="contract.pricingTerm.rate"
                                           v-on:keyup="rateChange"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('rate')">{{ errors.first('rate') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-lg-10 m-t-20" v-if="contract.quantity">
                            <div class="form-group row">
                                <label class="text-right col-sm-3 control-label col-form-label">Quantity</label>
                                <div class="input-group col-sm-7">
                                    <p class="form-control" readonly>{{contract.quantity}}{{contract.unit.symbol}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-lg-10 m-t-20" v-if="contract.amount">
                            <div class="form-group row">
                                <label class="text-right col-sm-3 control-label col-form-label">Amount</label>
                                <div class="input-group col-sm-7">
                                    <p class="form-control" readonly>{{contract.amount | money}}</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapGetters} from "vuex";
    import CurrencySelect from "../../../../protected/common/CurrencySelect";
    import Multiselect from 'vue-multiselect';

    export default {
        name: "PricingTerm",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {CurrencySelect, Multiselect},
        data() {
            return {
                submitted: false,
                isForward: false,
                contract: this.$parent.contract,
                pricingMethods: [
                    {
                        id: 1,
                        name: 'Flat'
                    },
                    {
                        id: 2,
                        name: 'Future'
                    },
                    {
                        id: 3,
                        name: 'Index'
                    }
                ],
                currency_symbol: null,
                selectedPricingMethod: null
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
        methods: {
            async init() {
                if(this.contract.pricingTerm.currency) {
                    this.$refs.reference.currency = {
                        "id": this.contract.pricingTerm.currency.id,
                        "name": this.contract.pricingTerm.currency.name,
                        "symbol": this.contract.pricingTerm.currency.symbol,
                        "plural": this.contract.pricingTerm.currency.plural,
                        "symbol_native": this.contract.pricingTerm.currency.symbol_native,
                        "decimals": this.contract.pricingTerm.currency.decimals,
                        "rounding": null,
                        "created_at": this.contract.pricingTerm.currency.created_at
                    };
                } else {
                    this.$refs.reference.currency = {
                        "id": null,
                        "name": null,
                        "symbol": null,
                        "plural": null,
                        "symbol_native": null,
                        "decimals": 2,
                        "rounding": null,
                        "created_at": null
                    };
                }
                if(this.contract.pricingTerm.method) {
                    this.selectedPricingMethod = this.contract.pricingTerm.method.name;
                }
                this.expressid = this.currentOrg.express_id;
            },
            async validate() {
                this.submitted = true;
                let valid      = await this.$validator.validate();
                return valid;
            },
            selectPricingMethod() {
                this.selectedPricingMethod = this.contract.pricingTerm.method.name;
                if(this.selectedPricingMethod === 'Flat') {
                    this.$refs.reference.currency      = {
                        "id": this.contract.goodsSerivces.rate.currency_id,
                        "name": this.contract.goodsSerivces.rate.currency_name,
                        "symbol": this.contract.goodsSerivces.rate.currency_symbol,
                        "plural": null,
                        "symbol_native": null,
                        "decimals": 2,
                        "rounding": null,
                        "created_at": null
                    };
                    this.contract.pricingTerm.currency = this.$refs.reference.currency;
                    this.calculateAmount();
                } else {
                    this.$swal({
                        title: `Pricing term - ${this.selectedPricingMethod}, is not yet implemented!`,
                        type: 'warning',
                        showCloseButton: true,
                    });
                }
            },
            setCurrency(e) {
                if(e) {
                    console.log(e);
                    this.contract.pricingTerm.currency = e;
                    this.currency_symbol               = e.symbol;
                    this.calculateAmount();
                }
            },
            calculateAmount() {
                if(this.contract.quantity && this.contract.pricingTerm.rate) {
                    this.contract.amount = {
                        amount: Number(this.contract.quantity) * Number(this.contract.pricingTerm.rate),
                        currency_id: this.contract.pricingTerm.currency.id,
                        currency_name: this.contract.pricingTerm.currency.name,
                        currency_symbol: this.contract.pricingTerm.currency.symbol
                    };
                }
            },
            rateChange() {
                if(this.contract.pricingTerm.rate === '') {
                    this.contract.amount = null;
                } else {
                    this.calculateAmount();
                }
            }
        }
    }
</script>

<style scoped>

</style>
